<template>
  <div>
    <d-row no-gutters class="page-header py-4 mb-2">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <h4>Lista oczekująca:
          <p class="mt-1 mb-0 patient-name">{{ patient.name + ' ' + patient.last_name }}</p>
        </h4>
      </d-col>
    </d-row>
    <d-card
      class="w-100"
      style="box-shadow: none;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">Placówka</th>
            <th scope="col" class="border-0">Wnioskuje o</th>
            <th scope="col" class="border-0 text-center">Data zgłoszenia</th>
            <th scope="col" class="border-0 text-center">Wizyty odwołane</th>
            <th scope="col" class="border-0 text-center">Status</th>
            <th scope="col" class="border-0 text-center">Akcje</th>
          </tr>
        </thead>
        <tbody v-if="loaded">
          <tr
            v-for="(reservation, reservationIndex) of reservations"
            :key="'reservation-' + reservationIndex">
            <td class="align-middle">
              {{ getInstitutionName(reservation.institution_id) }}
            </td>
            <td class="align-middle">
              {{ reservation.diagnosis_name }}
            </td>
            <td class="align-middle text-center">
              {{ reservation.created_at.slice(0, 10) }}
            </td>
            <td
              :class="{
              'align-middle text-center': true,
              'promising': cancelledVisitsPercent <= 10,
              'attention': cancelledVisitsPercent <= 20,
              'danger': cancelledVisitsPercent > 20
              }">
              {{ cancelledVisitsPercent }} %
            </td>
            <td class="align-middle text-center">
              <d-badge
                class="user-status"
                :theme="reservation.status === 'RL_TO_ACCEPT' ? 'primary' : 'success'">
                {{ reservation.status === 'RL_TO_ACCEPT' ? 'Do zaakceptowania' : 'Zaakceptowane' }}
              </d-badge>
            </td>
            <td
              class="align-middle text-center"
              style="width: 200px;">
              <d-button
                theme="info"
                class="mr-2"
                outline
                :disabled="actionInProgress"
                @click.prevent="downloadReservation(reservation.id)">
                <template v-if="!actionInProgress">
                  <i class="material-icons">cloud_download</i>
                  <span class="ml-2">Pobierz</span>
                </template>
                <template v-else>
                  <div class="spinner-border spinner-border-sm" role="status"></div>
                </template>
              </d-button>
              <d-button
                theme="primary"
                class="mr-2"
                @click.prevent="$router.push('/reservation_list/detale/' + reservation.id)"
                title="Szczegóły wniosku">
                <i class="material-icons">search</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="reservations.length === 0">
            <td
              colspan="6"
              class="text-center">
              Brak rezerwacji do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>
  </div>
</template>

<script>
import Vue from 'vue';
import ListUtils from '@/utils/ListUtils.js';

export default {
  name: 'patients-form-reservations',
  props: {
    allInstitutions: {
      type: Array,
      required: true
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    patient: {
      type: Object,
      required: true
    }
  },
  watch: {
    'isVisible': function (newValue) {
      if (newValue && !this.loaded) {
        this.loadItemsData();
      }
    }
  },
  data () {
    return {
      actionInProgress: false,
      loaded: false,
      loadError: false,
      reservations: []
    }
  },
  computed: {
    cancelledVisitsPercent () {
      let percent = 0;
      if (this.patient.count_cancelled_visits) {
        percent = (this.patient.count_cancelled_visits / this.patient.count_visits) * 100;
      }

      return percent.toFixed();
    }
  },
  mounted () {
    if (this.isVisible) {
      this.loadItemsData();
    }
  },
  methods: {
    loadItemsData () {
      Vue.set(this, 'loaded', false);
      Vue.set(this, 'loadError', false);

      let where = {
        patient_id: this.patient.id
      };
      ListUtils.loadItemsData(this, {
        endpoint: '/patients/reservation-list/items',
        listField: 'reservations',
        params: {
          where
        }
      });
    },
    downloadReservation (reservationID) {
      this.actionInProgress = true;

      this.$http.post('/patients/reservation-list/get-file/' + reservationID, {}, {
        responseType: 'blob'
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let filename = 'rezerwacja-nr-';
        link.setAttribute('download', filename + reservationID + '.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.actionInProgress = false;
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas pobierania',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
        this.actionInProgress = false;
      });
    },
    getInstitutionName (institutionID) {
      let institutionFound = this.allInstitutions.find(item => item.id === institutionID);

      if (institutionFound && institutionFound.name) {
        return institutionFound.name;
      }

      return 'brak';
    }
  }
}
</script>
